import { OTP } from "./constants";

export const checkShowNoPinConfirmationModal = (certificate) => {
    if (certificate.CertType === "Ivnosys") return false;

    if (certificate.CertType === "KeyVault" && certificate.IsWalletLinked) return false;
    
    return ((certificate.PinRequired === false && certificate.AuthenticationType !== OTP) || (!certificate.PinRequired && certificate.CertType === "Nebula"));
};

